






































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Competence from '@/competences/entities/competence'
import CompetenceFilter from '@/competences/entities/competence-filter'
import CompetencesService from '@/competences/services/competences-service'

@Component
export default class CompetencePicker extends Vue {
  private loading = false
  private search = ''
  private filter = new CompetenceFilter()
  private item: Competence | null = null
  private items: Competence[] = []

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  @Watch('search')
  private async searchChanged(val: string, old: string) {
    if (val && val !== old) {
      this.filter.search = val
      await this.loadAsync()
    }
  }

  private async loadAsync() {
    this.loading = true
    this.items = await CompetencesService.findAllAsync(this.filter)
    if (this.search && this.search.length > 0) {
      this.items.splice(0, 0, { id: 'create' } as Competence)
    }
    this.loading = false
  }

  private async emitChangeAsync(competence: Competence | null) {
    if (competence == null) {
      this.$emit('select', null)
    } else if (competence.id === 'create') {
      const newCompetence = new Competence()
      newCompetence.title = this.search
      this.$emit('create', newCompetence)
      await this.resetSearchAsync()
    } else {
      this.$emit('select', competence)
      await this.resetSearchAsync()
    }
    this.item = null
    this.search = ''
  }

  private async resetSearchAsync() {
    this.search = ''
    this.filter.search = ''
    await this.loadAsync()
  }

  private async mounted() {
    this.filter.isTemplate = true
    await this.loadAsync()
  }
}
